import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CouponValidationResult } from '../model/coupon-validation-result';
import { HttpUtil } from '../../../shared/util/http.util';
import { ApplicationConfig } from '../../../core/config/application.config';

@Injectable({
  providedIn: 'root',
})
export class CouponApiService {
  constructor(private readonly httpUtil: HttpUtil) {}

  public validateCoupon(
    code: string,
    productApiName: string
  ): Observable<CouponValidationResult> {
    return this.httpUtil.get(`${ApplicationConfig.apiUrl}/coupons/status`, {
      id: code,
      productApiName,
    });
  }

  public validateReferralCode(code: string): Observable<{ valid: boolean }> {
    return this.httpUtil.get(
      `${ApplicationConfig.apiUrl}/referral-codes/status`,
      {
        code,
      }
    );
  }
}
